<template>
    <v-container fluid class="pa-0">
        <PageHeader :contextStyle="contextStyle">
            <template #right>
                <router-link :to="{ name: 'sites-list-slide-site-edit', params: { sit_id: 0 } }">
                <v-btn small rounded color="primary"><v-icon>mdi-plus</v-icon> Nouveau</v-btn>
                </router-link>
            </template>
        </PageHeader>
    
        <!--<SiteForm v-if="( $route.params.sit_id !== undefined && parseInt( $route.params.sit_id ) >= 0 )"/>-->
        <v-card :class="($root.$mobileView) ? 'mt-0 mb-2 ml-0 mr-0 rounded-lg' : 'ma-4 rounded-lg'">
            <SitesList />
        </v-card>
    
    </v-container>
</template>
    
<script>
import PageHeader from '@/components/ui/PageHeader'
import SitesList  from '@/components/sites/SiteList'
//import SiteForm   from '@/components/sites/SiteForm'

export default {
    name: 'entities-page',
    props: ['contextStyle'],
    components: {
        PageHeader,
        SitesList
    },
    data: function () {
        return {
        }
    },
    computed: { },
    created(){},
    mounted: function (){

    },
    methods: {

    },
    beforeDestroy() {

    },
}
</script>